'use client'

import { SubmitContactForm } from '@/actions'
import { ButtonRoundStyle } from '@/components/common'
import { RHFTextField } from '@/components/form'
import { Form } from '@/components/form/form-provider'
import yup from '@/utils/yup-global'
import { contactSchema } from '@/validations'
import { yupResolver } from '@hookform/resolvers/yup'
import Stack from '@mui/material/Stack'
import { useTranslations } from 'next-intl'
import { useTransition } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

export const FromContact = () => {
  const [isPending, startTransition] = useTransition()
  const t = useTranslations('UserProfile')
  const method = useForm<yup.InferType<typeof contactSchema>>({ resolver: yupResolver(contactSchema) })
  const { handleSubmit, reset } = method
  const onSubmit = async (values: yup.InferType<typeof contactSchema>) => {
    startTransition(async () => {
      await SubmitContactForm(values)
        .then((r) => {
          toast.success(t('Gửi thông tin thành công'))
          reset()
        })
        .catch((error) => {
          toast.error(t('Gửi thông tin thất bại'))
        })
    })
  }
  return (
    <Form onSubmit={handleSubmit(onSubmit)} methods={method}>
      <Stack spacing={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <RHFTextField
            name="firstname"
            required
            label={t('firstname')}
            placeholder={t('enter-your', { name: t('firstname') })}
          />
          <RHFTextField
            name="lastname"
            required
            label={t('lastname')}
            placeholder={t('enter-your', { name: t('lastname') })}
          />
        </Stack>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <RHFTextField
            name="email"
            label={'Email'}
            placeholder={t('enter-your', { name: 'Email' })}
            required
          />
          <RHFTextField
            name="phone_number"
            label={t('phone')}
            required
            placeholder={t('enter-your', { name: t('phone') })}
          />
        </Stack>
        <RHFTextField
          name="title"
          required
          label={t('title')}
          placeholder={t('enter-your', { name: t('title') })}
        />
        <RHFTextField
          name="description"
          label={t('description')}
          required
          placeholder={t('enter-your', { name: t('description') })}
        />
        <ButtonRoundStyle
          sx={{
            textTransform: 'uppercase',
          }}
          type="submit"
          disabled={isPending}
          loading={isPending}
          variant="contained"
        >
          {t('Gửi thông tin')}
        </ButtonRoundStyle>
      </Stack>
    </Form>
  )
}
